export default __webpack_public_path__ + "static/media/earn.0ea9c63c.png";